export class ContainerNumberHelper{
  public static containerNumberIsValid(containerNumber: string): boolean{
      // Remove any non-alphanumeric characters and convert to upper-case.
      const csc = containerNumber.toUpperCase().replace(/[^A-Z0-9]+/g, '');

      // Check if length fits requirements.
      if (csc.length < 10 || csc.length > 11)
          return false;

      // Calculate check digit.
      var sum = 0;
      for (let i = 0; i < 10; i++) {

          // Map letters to numbers.
          let n = csc.charCodeAt(i);
          n -= n < 58 ? 48 : 55;

          // Numbers 11, 22, 33 are omitted.
          n += (n-1) / 10;

          // Sum of all numbers multiplied by weighting.
          sum += n << i;
      }

      // Modulus of 11, and map 10 to 0.
      const checksum = sum % 11 % 10;
      const lastNumber = +csc.substring(csc.length - 1) as number;

      return checksum === lastNumber;
  }

  public static containerNumberFormatIsValid(containerNumber: string): boolean {
    const cleaned = containerNumber.toUpperCase().replace(/[^A-Z0-9]/g, '');

    // Check format: 4 letters followed by 7 digits
    return /^[A-Z]{4}[0-9]{7}$/.test(cleaned);
  }
}
